import React, { useMemo, useState } from 'react';
import { Button } from '@saleshandy/design-system';
import { ChevronDown, ChevronUp } from '@saleshandy/icons';

import { Placement } from '../../../../../shared/design-system/components/overlay';
import Transfer from '../../../../../shared/design-system/components/transfer';

type IProps = {
  className?: string;
  selectClassName?: string;
  placeholder?: string;
  options: any[];
  optionRenderer: (option) => React.ReactNode;
  selectedOptionKey: string[];
  selectedOptionRenderer: (options) => React.ReactNode;
  onChange: (options) => void;
  isLoading?: boolean;
  shouldShowLoadMoreBtn?: boolean;
  onLoadMore?: VoidFunction;
  isLoadingMore?: boolean;
  showSearch?: boolean;
  onKeyDown?: (
    value: string,
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => void;
  filterOption?: (search: string, option: any, options: any[]) => boolean;
  resetProspectFiltersFieldsAttributesValue?: VoidFunction;
  btnClassName?: string;
  onSearch?: (value: string) => void;
  disabled?: boolean;
};

const ProspectFiltersMultiSelectDropdown: React.FC<IProps> = ({
  className,
  selectClassName,
  placeholder,
  options,
  optionRenderer,
  selectedOptionKey = [],
  selectedOptionRenderer,
  onChange,
  isLoading = false,
  shouldShowLoadMoreBtn = false,
  onLoadMore,
  isLoadingMore = false,
  showSearch = false,
  onKeyDown = () => null,
  filterOption = () => true,
  resetProspectFiltersFieldsAttributesValue,
  btnClassName = '',
  onSearch = () => null,
  disabled = false,
}) => {
  const [show, setShow] = useState(false);

  const selectedOptions = useMemo(
    () =>
      selectedOptionKey?.map((key) =>
        options.find((option) => option.key === key),
      ) || [],
    [selectedOptionKey, options],
  );

  return (
    <div
      className={`prospect-filters-multi-select-dropdown-container ${className}`}
    >
      <Transfer
        show={show}
        onToggle={(updatedShow) => {
          setShow(updatedShow);
          if (!updatedShow) {
            resetProspectFiltersFieldsAttributesValue?.();
          }
        }}
        className={`prospect-filters-multi-select-dropdown ${selectClassName}`}
        options={options}
        placement={Placement.BottomStart}
        selectedOptionKey={selectedOptionKey}
        optionRenderer={(option) => optionRenderer(option)}
        onChange={(updatedOptions) => {
          onChange(updatedOptions);
        }}
        isLoading={isLoading}
        multiSelect
        loadMoreMeta={{
          shouldShowLoadMoreBtn,
          onLoadMore,
          isLoadingMore,
        }}
        showSearch={showSearch}
        autoFocusSearch={showSearch}
        onKeyDown={onKeyDown}
        filterOption={filterOption}
        onSearch={onSearch}
      >
        <Button
          className={`transfer-select-btn btn-white w-1 prospect-filters-owners-select ${btnClassName}`}
          variant="tertiary"
          onClick={() => {
            if (!disabled) {
              setShow(!show);
            }
          }}
        >
          <div className="transfer-select-btn-content">
            {!selectedOptionKey || selectedOptionKey?.length === 0 ? (
              <span className="placeholder">{placeholder}</span>
            ) : (
              selectedOptionRenderer(selectedOptions)
            )}
          </div>
          <div className="bs-select-box-icon-wrapper">
            {show ? <ChevronUp /> : <ChevronDown />}
          </div>
        </Button>
      </Transfer>
    </div>
  );
};

export default ProspectFiltersMultiSelectDropdown;
